export default {
    namespaced: true,

    state: {},

    actions: {
        add(context, data) {
            window.axios.post('/logs/add', {
                type: data.type,
            });
        },
    },
}
